import { Component, OnInit, ViewChild } from '@angular/core';
import { NavParams, Platform } from '@ionic/angular';
import { Navigator } from 'src/app/components/menu/navigator';
import { LobbyService } from 'src/app/services/lobby/lobby.service';
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { GameHubControllerService } from "src/app/services/gameHub/game-hub-controller";
import { WebservicesService } from "src/app/services/webservices/webservices.service";
import SwiperCore, { Pagination, Navigation, Autoplay, SwiperOptions } from "swiper";
import { SwiperComponent } from 'swiper/angular';
import { UtilsService } from 'src/app/services/utils/utils.service';
SwiperCore.use([Autoplay, Pagination, Navigation]);
@Component({
  selector: 'game-details',
  templateUrl: './game-details.component.html',
  styleUrls: ['./game-details.component.scss'],
})

export class GameDetailsComponent implements OnInit {

  
  private readonly notFound = "N/A"

  private gamedata: any;
  private extaData: any;
  private gameName: string;
  private provider: string;
  private category: string;
  private rtp: string;
  private additionalImages: any;
  private wageringBonusContribution: string;
  private imagePath: string;
  private description: string;
  private minBet: string;
  private maxBet: string;
  public isAuthenticated: boolean = false;
  private isDemoEnabled: boolean = false;
  private isMobile: boolean = false;
  @ViewChild('slides') slides: SwiperComponent;
  public isWeb = true

  constructor(
    private utils: UtilsService,
    private webservices: WebservicesService,
    private gameHubControllerService: GameHubControllerService,
    private navigator: Navigator,
    private navParams: NavParams,
    public lobbyService: LobbyService,
    private userSessionService: UserSessionService,
    private platform: Platform
  ) {
    if (this.platform.is('capacitor')) {
      this.isMobile = true;
    }
  }

  ngOnInit() {
    this.gamedata = this.navParams.get('gamedata');
    var params: any = { "game_launcher_id": this.gamedata.id };

    this.webservices.get("games/get-casino-data", params).subscribe({
      next: (response: any) => {
        if (response) {
          this.extaData = response.payload;
          this.wageringBonusContribution = !!this.extaData.wager_bonus_contribution ? `${Number(this.extaData.wager_bonus_contribution) * 100}%` : this.notFound;
        }
      },
      error: (error: any) => {
        this.wageringBonusContribution = this.notFound;
        console.log("get-casino-data: error");
        console.log(error);
      },
    });




    this.gameName = this.gamedata.game_name || this.notFound;
    this.description = this.gamedata.description || this.notFound;
    this.provider = this.gamedata.display_name || this.notFound;
    this.category = this.gamedata.super_type || this.notFound;
    this.rtp = !!this.gamedata.RTP ? `${this.gamedata.RTP}%` : this.notFound;
    this.isWeb = !this.platform.is('mobile')
    this.userSessionService
      .getCustomerSubscription()
      .then((subscription) => this.subscribeToCustomer(subscription));
    this.updateAuthentication();

    const additionalImages = []
    const prePath = this.lobbyService.galleryImagePath;
    if (this.gamedata.imagename3) additionalImages.push(prePath + this.gamedata.imagename3)
    if (this.gamedata.imagename4) additionalImages.push(prePath + this.gamedata.imagename4)
    if (this.gamedata.imagename5) additionalImages.push(prePath + this.gamedata.imagename5)
    this.additionalImages = additionalImages

    if (additionalImages.length > 0) {
      additionalImages.unshift(prePath + this.gamedata.imagename2)
    } else {
      this.imagePath = prePath + this.gamedata.imagename2
    }

    if (!this.gamedata.imagename2 && additionalImages.length === 0) {
      const defaultImage = this.utils.getCDNAsset("images/game_placeholder.jpg")
      this.imagePath = defaultImage
    }

    const extraLaunchData = this.gamedata.extra_launch_data;
    this.minBet = !!extraLaunchData && !!JSON.parse(extraLaunchData).minBet ? `$${JSON.parse(extraLaunchData).minBet}` || this.notFound : this.notFound;
    this.maxBet = !!extraLaunchData && !!JSON.parse(extraLaunchData).maxBet ? `$${JSON.parse(extraLaunchData).maxBet}` || this.notFound : this.notFound;
  }

  updateAuthentication() {
    this.userSessionService.isAuthenticated().then((isAuthenticated) => {
      this.isAuthenticated = isAuthenticated;
    });
  }

  subscribeToCustomer(subscription) {
    subscription.subscribe(() => {
      this.updateAuthentication();
      let demoModeEnabled = false;
      let demoLoggedOutEnabled = false;

      if (!demoModeEnabled) {
        this.isDemoEnabled = false;
      }
      else if (!demoLoggedOutEnabled && !this.isAuthenticated) {
        this.isDemoEnabled = false;
      }
      else {
        this.isDemoEnabled = true;
      }
    });
  }

  launchCasinoGame() {
    if (!this.isAuthenticated) {
      // save the gameData for later launch
      // this.LobbyService.setWaitingGameData(gameData);
      this.navigator.dismiss();
      return this.openLoginModal(this.gamedata);
    }

    return this.gameHubControllerService.launchCasinoGame(this.gamedata);
  }

  openLoginModal(gameData) {
    this.lobbyService.setWaitingGameData(gameData);
    return this.navigator.navigateTo("LoginComponent");
  }

  onClose() {
    this.navigator.dismiss();
  };

}
